module.exports = __webpack_public_path__ + "img/hero.78db0e95.png";